export const CLASS_NAME_COMPONENT = "tg-menu";

export const PositionEnum = {
  BottomLeft: "bottom left",
  BottomCenter: "bottom center",
  BottomRight: "bottom right"
};

export const OriginEnum = {
  Left: "left",
  Center: "center",
  Right: "right"
};

/**
 * @param {string|number|null|undefined} str
 * @param {string} unit
 *
 * @returns {string|undefined}
 */
export const convertToUnit = (str, unit = "px", defaultValue = undefined) => {
  if (str === null || str === "") {
    return defaultValue;
  } else if (isNaN(Number(str))) {
    return String(str);
  } else {
    return `${Number(str)}${unit}`;
  }
};
